import {Box, Stack, Tooltip, Typography} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {GlobalAccountType} from "../domain/GlobalAccountType";
import {buildGlobalAccountTypeIcon} from "../util/GlobalAccountTypeUtils";

interface DisplayNameWithGlobalAccountTypeProps {
    displayName: string | undefined;
    globalAccountType: GlobalAccountType;
}

export default function DisplayNameWithGlobalAccountType({displayName, globalAccountType}: DisplayNameWithGlobalAccountTypeProps) {
    const {t} = useTranslation();
    const globalAccountTypeLabel = t(`domain.globalAccountType.${globalAccountType}`);

    return (
        <Stack>
            <Typography variant='overline'>{t('domain.common.displayName')}</Typography>
            <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <Typography>{displayName || '-'}</Typography>
                <Tooltip title={globalAccountTypeLabel}>
                    <Box component={"span"} aria-label={globalAccountTypeLabel}>
                        {buildGlobalAccountTypeIcon(globalAccountType)}
                    </Box>
                </Tooltip>
            </Stack>
        </Stack>
    );
}
